import React, { Fragment } from 'react';

import { formatNumber } from '../../../Helpers/FormatNumber';

import styles from './Quantity.module.css';
import { t } from 'i18next';

const Quantity = ({ quantity = 0, unit = 'unit' }) => {
  return (
    <Fragment>
      <div className={styles.quantityPadding}>
        {formatNumber(isNaN(quantity) ? 0 : quantity)}
      </div>
      <div className={styles.quantityUnit}>
        {/* {t('common.unit') }
        {t('common.unit') && <Fragment>({t('common.s')})</Fragment>} */}
        {unit}
        {unit && <Fragment>(s)</Fragment>}
      </div>
    </Fragment>
  );
};

export default Quantity;
